export const colors = {
  backgroundColor: "bg-[#a9a9a921]",
  //primaryBackground: "bg-[#0047c7]",
  primaryBackground: "bg-[#1f1463]",
  primaryBorder: "border-[#1f1463]",
  primaryText: "text-[#1f1463]",
};
